export default __webpack_public_path__ + "static/media/digital-display.a21137b3.png";